import persistReducer from "redux-persist/lib/persistReducer";
import storage from "redux-persist/lib/storage";
import { jarvisPrimeExistingHoldingConstants } from "./jarvisPrimeExistingHoldingConstants";

const initialState = {
  primeList: [],
  stockList: [],
  loading: {
    primeList: 0,
    stockList: 0,
  },
  initialCalled: {
    primeList: 0,
    stockList: 0,
  },
};

export const jarvisPrimeExistingHoldingReducer = persistReducer(
  {
    storage,
    key: "primeExistingHolding",
    blacklist: ["loading"],
  },

  (state = initialState, { type, payload }) => {
    switch (type) {
      case jarvisPrimeExistingHoldingConstants.EXISTING_HOLDING_REQUEST: {
        return {
          ...state,
          loading: {
            ...state.loading,
            primeList: 1,
          },
          primeList: state.primeList,
        };
      }

      case jarvisPrimeExistingHoldingConstants.EXISTING_HOLDING_RESPONSE: {
        return {
          ...state,
          loading: {
            ...state.loading,
            primeList: 0,
          },
          initialCalled: {
            ...state.initialCalled,
            primeList: 1,
          },
          primeList: payload,
        };
      }

      // STOCK LIST

      case jarvisPrimeExistingHoldingConstants.STOCK_LIST_REQUEST: {
        return {
          ...state,
          loading: {
            ...state.loading,
            stockList: 1,
          },
          stockList: initialState.stockList,
        };
      }

      case jarvisPrimeExistingHoldingConstants.STOCK_LIST_RESPONSE: {
        return {
          ...state,
          loading: {
            ...state.loading,
            stockList: 0,
          },
          initialCalled: {
            ...state.initialCalled,
            stockList: 1,
          },
          stockList: payload,
        };
      }
      case jarvisPrimeExistingHoldingConstants.JARVIS_PRIME_RESET_EXISTING_HOLDING_DATA: {
        return initialState;
      }

      default:
        return state;
    }
  }
);
